type Props = {
    /** Name of the lumina App */
    appName: string;
    /** Image of the application logo */
    appLogo?: React.ReactElement;
    /** Link to the card application */
    link: string;

};
const ProductResourceCard = (props: Props) => {
    const {
        appName,
        appLogo,
        link,
    } = props;

    return (
        <a href={link} target="_blank" rel="noreferrer noopener" >
            <button
                className={['flex flex-col mr-8 mt-8 items-center justify-items-center p-2',
                    'bg-white border-1.5 shadow-card border-card-normal rounded-md',
                    'hover:border-card-hover outline-0 focus-visible:border-card-hover active:shadow-none',
                ].join(' ')}
                style={{
                    width: '17.25rem',
                    height: '9.9rem',
                }}
                onClick={ () => {}}
                type='button'>

                <span className='mt-5 w-shortcut place-self-center'>
                    { appLogo }
                </span>
                <div className='flex flex-col text-left place-self-center '>
                    <span className='text-label-xl font-bold'>
                        { appName }
                    </span>
                </div>
            </button>
        </a>
    );
};

export default ProductResourceCard;